import Alert from "features/shared/alerts/components/Alert";
import AlertParam from "features/shared/alerts/dtos/AlertParam";
import AlertSimplified from "features/shared/alerts/dtos/AlertSimplified";
import IContentDialogService from "features/shared/components/contentDialog/IContentDialogService";
import IDataFilterService from "features/shared/components/dataFilter/IDataFilterService";
import { useInjection } from "infrastructure/ioc/ioc.react";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import {
  AlertsAction,
  removeAlert,
} from "infrastructure/store/alerts/AlertsActions";
import React, { Dispatch } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import styles from "./notificationmenuitem.module.scss";

interface Props {
  alert: AlertSimplified;
  bellRef: React.MutableRefObject<any>;
}

const NotificationMenuItem = ({ alert, bellRef }: Props) => {
  // translations
  const tLabels = useTranslation("shared\\components").t;

  // DI
  const dialogService = useInjection<IContentDialogService>(
    IocTypes.ContentDialogService
  );

  const dataFilterService = useInjection<IDataFilterService>(
    IocTypes.DataFilterService
  );

  // STORE
  const alertDispatch = useDispatch<Dispatch<AlertsAction>>();

  // HANDLERS
  const handleAlertOnClose = (alert: AlertSimplified) => {
    if (!alert.alertId) return;
    alertDispatch(removeAlert(alert.alertId));

    dialogService.closeDialog();
  };

  const openModalHandler = () => {
    dialogService.openDialog(tLabels("notificationMenuItem.dialogTitle"), renderContent);
  };

  const handleOnClickLinkButton = (alertParam?: AlertParam) => {
    if (!alertParam) return;

    const gridId = dataFilterService.getGridIdByRoute(alertParam?.route ?? "");
    if (!gridId) return;

    bellRef.current.click();

    dataFilterService.storeSetParams(
      gridId,
      undefined,
      new URLSearchParams(alertParam.queryParams)
    );

    //FIXME: odebrat timeout a vyřeit jinak
    setTimeout(() => {
      dialogService.closeDialog();
    }, 0);
  };

  // FUNCTIONS
  // f-ce for render conent in modal
  const renderContent = () => {
    return (
      <Alert
        className="m-4"
        alertObj={alert}
        titleView
        closable={true}
        onClose={handleAlertOnClose}
        onClickLinkButton={handleOnClickLinkButton}
      />
    );
  };

  // render
  return (
    <div className={`dropdown-item ${styles.item}`} onClick={openModalHandler}>
      <Alert
        alertObj={alert}
        titleView
        truncate
        className={styles.alert}
        onClickLinkButton={handleOnClickLinkButton}
      />
    </div>
  );
};

export default NotificationMenuItem;
